module.exports = __webpack_public_path__ + "img/pdf.5d470ca5.svg";